/* eslint-disable class-methods-use-this */
import DirectoryService from './DirectoryService';

class MicrosoftDirectoryService implements DirectoryService {
  readonly name = 'Microsoft';

  // We do not have any restrictions on changing RSVP for Microsoft.
  canChangeRsvp = () => true;

  showEmployeeDirectoryIntegrationErrorInOrgCalendarPreference = () => false;
}

export default MicrosoftDirectoryService;
